import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    fragmentContainer: {
        // marginTop: '10px',
        width: '100%',
        paddingTop:'10px',
        paddingLeft:'5px',
        paddingRight:'5px',
        flexDirection: 'row'
    },
    label: {
        width: '100%',
        fontSize: 10
    },
});

  const Seller = ({invoice}) => (
    <>
        <View style={{...styles.fragmentContainer, marginTop:'-5px'}}>
            <Text key={'seller'} style={styles.label}>
                Vendedor(a): {invoice.condicaoComercial?.seller?.name}
            </Text>
        </View>
    </>
  );
  
  export default Seller